<template>
	<!-- 防盗 -->
	<div class="unpdataOldTextBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">防盗</p>
				</div>
			</div>
		</van-sticky>
		<div class="fangdaoListBox">
			<div class="fangdaoitem" @click="firstSelectBox('V文购买比例')">
				<div>
					<span>V文购买比例</span>
					<img src="../../assets/img/selectpink.png" alt="" v-show="selectTitle == 'V文购买比例' ? true : false">
					<img src="../../assets/img/selegray.png" alt="" v-show="selectTitle != 'V文购买比例' ? true : false">
				</div>
				<input class="right_txt" type="text" placeholder="默认值" :value="firstselectValue1" />
			</div>
			<div class="fangdaoitem" @click="firstSelectBox('防盗时间')">
				<div>
					<span>防盗时间</span>
					<img src="../../assets/img/selectpink.png" alt="" v-show="selectTitle == '防盗时间' ? true : false">
					<img src="../../assets/img/selegray.png" alt="" v-show="selectTitle != '防盗时间' ? true : false">
				</div>
				<input class="right_txt" type="text" placeholder="小时" :value="firstselectValue2  + '小时'" />
			</div>
			<div class="fangdaoitem" @click="firstSelectBox('防盗方式')">
				<div>
					<span>防盗方式</span>
					<img src="../../assets/img/selectpink.png" alt="" v-show="selectTitle == '防盗方式' ? true : false">
					<img src="../../assets/img/selegray.png" alt="" v-show="selectTitle != '防盗方式' ? true : false">
				</div>
				<input class="right_txt" type="text" placeholder="方式" v-if="firstselectValue3 == 0 ? true : false" />
				<input class="right_txt" type="text" placeholder="方式" v-else :value="firstselectValue3  + '方式'" />
			</div>
			<div class="fangdaoitem">
				<div>
					<span>防盗提示</span>
					<img src="../../assets/img/selegray.png" alt="">
				</div>
				<div class="right_txt textareaBox"><input type="text" maxlength="30"  @input="descInput" v-model="desc" placeholder="最多输入30个字"><span class="xianzhi">{{remnant}}/30</span></div>
			</div>
		</div>
		<div  class="submitBaocun">
			<img src="../../assets/img/flower.png" alt="" class="flower" />
			<button @click="plrate_edit">保存</button>
		</div>
		<!-- //弹框 -->
		<div class="selectItem" v-show="firstSelect">
			<div class="selectItem_left" @click="closeFn"></div>
			<div class="selectItem_right">
				<div class="selectItem_right_title">
					<img src="../../assets/img/close.png" alt="" @click="closeFn">
					<p>{{selectTitle}}</p>
				</div>
				<ul v-if="selectTitle == 'V文购买比例' ? true : false">
					<li v-for="(selectItem,index) in firstSelectLists1" :key="index" @click="firstselectItemFn1(selectItem,index)">
						<div>
							<img src="../../assets/img/gmicon.png" alt="" v-show="firstselectIndex == index ? false : true" />
							<img src="../../assets/img/gmiconActive.png" alt="" v-show="firstselectIndex == index ? true : false">
						</div>
						<span :class="firstselectIndex == index ? 'active_color' : '' ">{{selectItem}}</span>
					</li>
				</ul>
				<ul v-if="selectTitle == '防盗时间' ? true : false">
					<li v-for="(selectItem,index) in firstSelectLists2" :key="index" @click="firstselectItemFn2(selectItem,index)">
						<div>
							<img src="../../assets/img/gmicon.png" alt="" v-show="firstselectIndex == index ? false : true" />
							<img src="../../assets/img/gmiconActive.png" alt="" v-show="firstselectIndex == index ? true : false">
						</div>
						<span :class="firstselectIndex == index ? 'active_color' : '' ">{{selectItem}}小时</span>
					</li>
				</ul>
				<ul v-if="selectTitle == '防盗方式' ? true : false">
					<li v-for="(selectItem,index) in firstSelectLists3" :key="index" @click="firstselectItemFn3(selectItem.txt,selectItem.id)">
						<div>
							<img src="../../assets/img/gmicon.png" alt="" v-show="firstselectIndex3 == selectItem.id ? false : true" />
							<img src="../../assets/img/gmiconActive.png" alt="" v-show="firstselectIndex3 == selectItem.id ? true : false">
						</div>
						<span :class="firstselectIndex3 == selectItem.id ? 'active_color' : '' ">{{selectItem.txt}}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				selectTitle:'',
				firstselectValue1:'',//V文防盗比例
				firstselectValue2:'',//防盗时间（单位小时）
				firstselectValue3:'',//防盗类型
				firstSelect: false,
				firstselectIndex: 0, //选中索引
				firstselectIndex3: 0,
				firstSelectLists1: ["100%", "90%", "80%","70%","60%","50%","40%","30%","20%","10%","0%"],
				firstSelectLists2: ["12", "11", "10","9","8", "7","6","5", "4","3", "2","1"],
				firstSelectLists3:[{id:0,txt:"显示重复章"},{id:1,txt:"显示提示文字"}],
				desc: '', //文本域内容 --- 防盗提示
				remnant: 0, //开始字数
			}
		},
		created() {
			this.book_id = this.$route.query.bookEditId;
			this.plrate_info();
		},
		methods: {
			firstSelectBox(data) { //下拉框选项 显示 -- 1
				this.firstSelect = !this.firstSelect;
				this.selectTitle = data
			},
			firstselectItemFn1(value, index) { //下拉框选择 -- 1
				this.firstselectValue1 = value;
				this.firstselectIndex = index;
				this.firstSelect = !this.firstSelect;
			},
			firstselectItemFn2(value, index) { //下拉框选择 -- 1
				this.firstselectValue2 = value;
				this.firstselectIndex = index;
				this.firstSelect = !this.firstSelect;
			},
			firstselectItemFn3(value, index) { //下拉框选择 -- 1
				this.firstselectValue3 = value;
				this.firstselectIndex3 = index;
				this.firstSelect = !this.firstSelect;
			},
			// 文本域字数限制
			descInput() {
				let txtVal = this.desc.length;
				this.remnant = 0 + txtVal;
			},
			back(){
				this.$router.push('/updataoldtext')
			},
			closeFn(){
				this.firstSelect = false;
			},
			plrate_info(){
				this.$axios.post(this.$api.plrate_info,{
					book_id: this.book_id
				}).then(res => {
					console.log(res.data.data)
					this.firstselectValue1 = res.data.data.proportion;
					this.firstselectValue2 = res.data.data.pirate_time;
					this.firstselectValue3 = res.data.data.pirate_type;
					this.desc = res.data.data.pirate_message;
				})
			},
			plrate_edit(){
				if(this.firstselectValue1 == ''){
					Toast('请选择V文购买比例');
					return false;
				}else if(this.firstselectValue2 == ''){
					Toast('请选择防盗时间');
					return false;
				}else if(this.firstselectValue3 == ''){
					Toast('请选择防盗方式');
					return false;
				}else {
					this.$axios.post(this.$api.plrate_edit,{
						book_id: this.book_id,//书本id
						proportion: this.firstselectValue1,//V文防盗比例
						pirate_time: this.firstselectValue2,//防盗时间（单位小时）
						pirate_type: this.firstselectIndex3,//防盗类型
						pirate_message: this.desc,//防盗提示
					}).then(res => {
						Toast(res.data.msg);
						this.$route.push('/updataoldtextinfo')
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.unpdataOldTextBox {
		height: 100vh;
		overflow-x: hidden;
		background-color: #fff;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//
		.fangdaoListBox{
			background-color: #fff;
			.fangdaoitem{
				display: flex;
				line-height: 90px;
				margin: 0 16px;
				border-bottom: 1px solid #f0f0f0;/*no*/
				div{
					position: relative;
					margin-right: 60px;
					span{
						padding-right: 20px;
						font-size: 30px;/*px*/
						color:#3d3d3d;
					}
					
					img{
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						width: 20px;
					}
				}
				input{
					flex:1;
					text-align: right;
				}
				.right_txt{
					margin-right:0;
					flex:1;
					text-align: right;
					font-size: 30px;/*px*/
					color:#a3a3a3;
					input{
						width: 100%;
						text-align: right;
						padding-right:10px;
					}
				}
				.right_txt.textareaBox {
					display: inline-block;
					position: relative;
					margin-right: 80px;
					.xianzhi {
						background-color: #fff;
						position: absolute;
						top: 50%;
						right: -100px;
						transform: translateY(-50%);
						color: #999999;
						line-height: 60px;
						font-size: 32px;
						/*px*/
					}
				}
			}
		}

		//保存
		.submitBaocun{
			text-align: center;
			margin-top: 352px;
			position: relative;
			.flower{
				position: absolute;
				top: -60px;
				left: 20%;
				width: 100px;;
			}
			button{
				border: 0;
				line-height: 80px;
				font-size: 32px;/*px*/
				width: 90%;
				background-color: #FF4081;
				color:#fff;
				border-radius: 10px;
			}
		}
		
		
		
		
		//下拉列表
		.selectItem {
			width: 100vw;
			height: 100vh;
			overflow: hidden;
			position: absolute;
			top: 160px;
			right: 0px;
			display: flex;
		
			.selectItem_left {
				width: 30vw;
				background-color: rgba(0, 0, 0, .3);
			}
		
			.selectItem_right {
				flex: 1;
				background-color: #fff;
				.selectItem_right_title{
					height: 80px;
					line-height: 80px;
					width: 100%;
					position: relative;
					img{
						position: absolute;
						top: 50%;
						left: 20px;
						transform: translateY(-50%);
						width: 25px;
					}
					p{
						text-align: center;
						width: 100%;
						font-size: 30px;/*px*/
						font-weight: 600;
					}
				}
				ul {
					background-color: #fff;
					z-index: 1000;
					position: relative;
					padding: 0 20px;
					li {
						padding: 0px 20px;
						display: flex;
						position: relative;
						
						line-height: 80px;
						color:#a3a3a3;
						div{
							width: 20%;
							margin: 0 20px;
							img {
								width: 30px;
								padding-right: 10px;
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
							}
						}
						span{
							flex:1;
							font-size: 30px;/*px*/
							text-align: left;
							padding-left: 40px;
							border-bottom: 1px solid #f0f0f0;
							/*no*/
						}
					}
		
					.active_color {
						color: #3d3d3d;
					}
				}
			}
		}
}
</style>
